export default {
  title: "Fondamentaux de la Programmation",
  subtitle: "Poser les Bases de Pratiques de Codage Efficaces",
  overviewTitle: "Aperçu du Cours",
  overview: `<p className="cs-m0">
              Ce cours complet est conçu pour vous initier aux principes fondamentaux de la programmation, servant de base solide pour les développeurs en herbe. Vous explorerez les concepts de programmation de base tels que les variables, les structures de contrôle, les types de données et les algorithmes, qui sont essentiels pour écrire un code efficace dans divers langages de programmation.
            </p>
            <br />
            <p className="cs-m0">
              Le programme couvre des langages populaires comme Python, Java et JavaScript, vous permettant d'acquérir une expérience pratique en codage grâce à des exercices et des projets pratiques. Vous apprendrez à résoudre des problèmes en utilisant la pensée logique et à développer des algorithmes qui optimisent votre code pour l'efficacité et la lisibilité.
            </p>
            <br />
            <p className="cs-m0">
              Que vous soyez un complet débutant ou que vous cherchiez à renforcer vos compétences existantes, ce cours vous fournira les connaissances et la confiance nécessaires pour aborder des concepts de programmation plus avancés et des défis du monde réel.
            </p>`,
};
